<template>
  <div class="container-fluid page-container">
    <div v-if="lead !== null" class="row page-header__container mb-4 pb-3">
      <page-heading :class="'align-items-center'" :back-url="'my-lead'" :url-params="{code:lead.code}" :title="$t('Report lead')" />
    </div>
    <div v-if="lead !== null" class="row mt-3">
      <div class="col-12">
        <report-lead :action="reportAction" />
      </div>
    </div>
    <spinner v-else :display-loading="true" />
  </div>
</template>

<script>
import ReportLead from "@/components/form/ReportLead";
import PageHeading from "@/components/control/PageHeading";
import {ACTIVE_LEAD} from "@/store/leads/mutation-types";
import Spinner from "@/components/animation/Spinner";

export default {
  name: "LeadReport",
  components: {Spinner, PageHeading, ReportLead},
  props: ['action'],
  data: function() {
    return {
      reportAction: this.action ?? 'report',
    }
  },
  computed: {
    lead: {
      get: function() {
        return this.$store.state.leads.ACTIVE_LEAD;
      },
      set: function(value) {
        this.$store.commit(ACTIVE_LEAD, value);
      }
    },
  },
  methods: {
    canAccess: function(lead) {
      return (
        (
          ((lead.reportStatus === null || this.isExtended(lead)) && this.reportExpired(lead) === false)
          || lead.isAppealable
        ) && !lead.outstanding_report
        && (lead.query_result === null || (lead.query_result === false && lead.isAppealable && !this.appealExpired(lead)))
      );
    },
    isExtended:  function(lead) {
      return lead.reason === null && lead.extensions_granted === true;
    },
    reportExpired: function(lead) {
      return (new Date(lead.report_by) < new Date()) ? lead.report_by : false;
    },
    appealExpired: function(lead) {
      return lead.isAppealable ? ((new Date(lead.appeal_by) < new Date()) ? lead.appeal_by : false) : false;
    },
  },
  created: function () {
    this.lead = null;
    this.error = null;
    if (this.$route.query.action) {
      this.reportAction = this.$route.query.action;
    }
    this.$api.leads.getLead(this.$route.params.code).then(response => {
      const lead = response.data.data.lead;
      const banReport = response.data.data.isReportBanned;
      if (!this.canAccess(lead) || banReport) {
        this.$router.push({name: 'my-lead', params:{code: lead.code}});
      }
      this.lead = lead;
    }).catch(() => {
      this.lead = null;
      this.error = true;
    });
  },
}
</script>

<style scoped>

</style>
